
<template>
    <!-- <div class="item_content transition_animate" :class="animateClas" :style="modata.WContent|setWordStyle(rootValue)">
        <div style="display: flex;align-items: center;" :style="modata.WContent|setDirectionStyle">
            <div class="title" :style="modata.WContent.titleStyle|setTxtStyle(modata.WContent.direction,rootValue)" v-if="modata.WContent.nav[index].title">{{modata.WContent.nav[index].title}}</div>
            <div class="describe" :style="modata.WContent.describeStyle|setTxtStyle(modata.WContent.direction,rootValue)" v-if="modata.WContent.nav[index].describe">{{modata.WContent.nav[index].describe}}</div>
            <button class="oper-btn pointer" :style="modata.WContent.btnStyle|setBtnStyle(rootValue)" v-if="modata.WContent.nav[index].btn" @click="pageNavigate(modata.WContent.nav[index].linkUrl)">{{modata.WContent.nav[index].btn}}</button>
        </div>
    </div> -->
     <div class="item_content" :class="{'item_content_position':!contentObj.showType||contentObj.showType==1}" :style="contentObj|setWordStyle(proportion)">
        <div style="display: flex;align-items: center;" :style="contentObj|setDirectionStyle" v-if="nav">
            <div class="title" :style="contentObj.titleStyle|setTxtStyle(contentObj.direction,rootValue,proportion)" v-if="nav.title">{{nav.title}}</div>
            <div class="describe" :style="contentObj.describeStyle|setTxtStyle(contentObj.direction,rootValue,proportion)" v-if="nav.describe">{{nav.describe}}</div>
            <button class="oper-btn pointer" :style="contentObj.btnStyle|setBtnStyle(rootValue,proportion)" v-if="nav.btn" @click="pageNavigate(nav.linkUrl)">{{nav.btn}}</button>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'btnModule',
        components: {},
        props: {
            type: {         //展示类型 preview预览模块 setting设置模块
                type: String,
                default: 'preview'
            },
            index: {        //索引
                type: Number
            },
            animateShow: {     
                type: String
            },
            nav:{
                type: Object,
                default:()=>{},
            },
             proportion: {
                type: Number,
                default:1,
            },
            handBack:{
              type:Boolean,
              default:false,
            },
            contentObj:{
                type: Object,
                  default: function () {
                    return { 
                        moduleSpac:0,
                        imgSpac:20,
                        direction:"column",
                        rowType:"between",
                        seatx:"center",
                        seaty:"left",
                        margin:[20,0,0,0],
                        titleStyle:{color:"#333",size:"16",mgb:"4"},
                        describeStyle:{color:"#888",size:"12",mgb:"4"},
                        btnStyle:{color:"#fff",size:"16",width:80,},
                        showType:"1",
                    }
                }
            },
        },
        data() {
            return {
                animateClas:"",
                rootValue:this.$store.state.rootValue||1,
            }
        },
        mounted() {


        },
        beforeDestroy() {
           
        },
        methods: {

            bindPage(item){
                if(!item.btn){
                    this.pageNavigate(item.linkUrl)
                }
            },
           
            pageNavigate(path){
                if(this.handBack){
                    // this.$emit()
                    this.$emit("callback", {});
                    return
                }
                if(!path){
                    return
                }
                if(/^(https?:|mailto:|tel:)/.test(path)){
                window.open(path)
                }else{
                    this.$router.push(path)
                }
            },
        },
        watch: {
            animateShow(newVal){
                if(newVal=="animate"){
                //  this.animateClas='animate__animated animate__backInLeft';
                 this.animateClas='transition_fromBelow';
                }
               
            },
         
        },
        filters: {

           setWordStyle(WContent,proportion){
              let type={left:"flex-start",center:"center",right:"flex-end",}
                let style={
                    justifyContent:type[WContent.seaty]||"center",
                    alignItems:type[WContent.seatx]||"center",
                };
                let margin=WContent.margin;
                if(margin && margin.length){
                    let newMargin=[0,0,0,0];
                    margin.forEach((item,index) => {
                    newMargin[index]=((item||0)*proportion)+"px";
                    });
                    style.padding=newMargin.join(" ");
                    return style;
                }
                return style

           },
           setDirectionStyle(WContent){
            let direction=WContent.direction;
             let style={
                flexDirection:direction||"column",
             };
             if(direction=="row" && WContent.rowType=="between"){
              style.justifyContent="space-between";
              style.width="100%";
             }
             return style
           },

           setTxtStyle(obj,direction,rootValue,proportion){
            if(!obj){ return ""; }
            let style= {
                    color:obj.color||"#333",
                    fontSize:((obj.size||14)/rootValue)+"rem",
                    fontWeight:obj.weight||500,
                };
                style[direction=="row"?"marginRight":"marginBottom"]=((obj.mgb||0)*proportion)+"px";
                return style
           },
           setBtnStyle(obj,rootValue,proportion){
            if(!obj){ return ""; }
             let styleObj={
                    color:obj.color||"#333",
                    fontSize:((obj.size||14)/rootValue)+"rem",
                    borderColor:obj.color||"#333",
                    width:obj.width?(obj.width/rootValue)+"rem":"auto",
                    fontWeight:obj.weight||500,
                }
                if(!obj.width){
                    styleObj.padding="0 20px";
                }
            return styleObj;
           },




        },
    }
</script>

<style scoped>

/* 按钮 */
.item_content{
   width: 100%;

   display: flex;
   flex-direction: column;
   box-sizing: border-box;
   padding: 1px;
   line-height: 1;
}
.item_content_position{
   position: absolute;
   top: 0;
   left: 0;
  height: 100%;
}
.item_content .oper-btn{
  background-color: transparent;
  border: solid 1px #fff;
  color: #fff;
  line-height: 2;
  border-radius: 5px;
  font-size: 14px;
  letter-spacing: 2px;
    width: 90px;
  text-align: center;
}
.oper-btn:hover{
  background-color: #fff !important;
  border-color: #fff !important;
  color: #333 !important;
}

.transition_animate{
    transition:transform 0.8s ;
    transform: translateY(50%);
}
.transition_fromBelow{
    transform:translateY(0)
}

</style>


